module.exports = __webpack_public_path__ + "public/img/ico-battery-status-ok.b294517b.svg";